import React, { FC } from 'react';
import { Box, Skeleton, Stack, useMediaQuery, useTheme } from '@mui/material';

export const TradesTableSectionSkeleton: FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const columnsCount = isMobile ? 5 : 9; // Show fewer columns on mobile

  return (
    <Box
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        minHeight: '400px',
        flex: '1 1 100%',
        minWidth: 0,
        padding: `${theme.spacing(8)} ${theme.spacing(4)}`,
      })}
    >
      {/* Header Skeleton */}
      <Stack
        direction={{
          xs: 'column',
          md: 'row',
        }}
        justifyContent="space-between"
        alignItems={{
          xs: 'flex-start',
          md: 'center',
        }}
        gap={{
          xs: 3,
          md: 0,
        }}
      >
        {/* Left Section */}
        <Stack
          direction={{
            xs: 'column',
            lg: 'row',
          }}
          alignItems={{
            xs: 'flex-start',
            lg: 'center',
          }}
          gap={3}
        >
          <Skeleton variant="text" width={80} height={24} />
          <Skeleton variant="rounded" width={120} height={32} />
        </Stack>

        {/* Right Section */}
        <Stack
          direction={{
            xs: 'column',
            sm: 'row',
          }}
          alignItems="center"
          gap={{
            xs: 2,
            sm: 5,
          }}
        >
          <Skeleton variant="rounded" width={140} height={36} />
          <Stack direction="row" gap={2}>
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="circular" width={24} height={24} />
          </Stack>
        </Stack>
      </Stack>

      {/* Table Skeleton */}
      <Box
        sx={(theme) => ({
          marginTop: theme.spacing(4),
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: theme.spacing(2),
          overflow: 'hidden',
        })}
      >
        {/* Table Header */}
        <Stack
          direction="row"
          sx={(theme) => ({
            backgroundColor: theme.palette.background.paper,
            padding: theme.spacing(2),
            borderBottom: `1px solid ${theme.palette.divider}`,
          })}
        >
          {Array.from({ length: columnsCount }).map((_, index) => (
            <Box key={index} sx={{ flex: 1, marginRight: 2 }}>
              <Skeleton variant="text" width="60%" height={20} />
            </Box>
          ))}
        </Stack>

        {/* Table Rows */}
        {Array.from({ length: 5 }).map((_, rowIndex) => (
          <Stack
            key={rowIndex}
            direction="row"
            sx={(theme) => ({
              padding: theme.spacing(2),
              borderBottom:
                rowIndex < 4 ? `1px solid ${theme.palette.divider}` : 'none',
            })}
          >
            {Array.from({ length: columnsCount }).map((_, cellIndex) => (
              <Box key={cellIndex} sx={{ flex: 1, marginRight: 2 }}>
                <Skeleton
                  variant="text"
                  width={
                    cellIndex === 0 ? '80%' : cellIndex === 1 ? '70%' : '50%'
                  }
                  height={20}
                />
              </Box>
            ))}
          </Stack>
        ))}
      </Box>
    </Box>
  );
};
